import { BeginEndTimestamp } from '@stores/MomentMerge/MomentMergeStore';

export const useSentenceCut = (sentence: BeginEndTimestamp, moment: BeginEndTimestamp | null) => {
  if (!moment) {
    return { cutLeftPercent: 0, cutRightPercent: 0, isCut: false };
  }

  const cutLeft = sentence.startTime < moment.startTime ? moment.startTime - sentence.startTime : 0;
  const cutRight = sentence.endTime > moment.endTime ? sentence.endTime - moment.endTime : 0;
  const segmentLength = sentence.endTime - sentence.startTime;
  const cutLeftPercent = segmentLength > 0 && cutLeft > 0 ? (cutLeft / segmentLength) * 100 : 0;
  const cutRightPercent = segmentLength > 0 && cutRight > 0 ? (cutRight / segmentLength) * 100 : 0;
  const isCut = cutLeftPercent > 0 || cutRightPercent > 0;

  return { cutLeftPercent, cutRightPercent, isCut };
};
